export default "__VITE_ASSET__c672bebb__"